import { apiClient } from '@shared/utils/api-client';
import type { PickupPoint, CreatePickupPointDto, UpdatePickupPointDto } from '../types';

export interface AddExceptionDto {
  date: string;
  from?: string;
  to?: string;
  reason?: string;
  enabled: boolean;
}

export interface UpdateExceptionDto {
  date?: string;
  from?: string;
  to?: string;
  reason?: string;
  enabled?: boolean;
}

export const pickupPointsApi = {
  getAll: async (): Promise<PickupPoint[]> => {
    return apiClient.get<PickupPoint[]>('/pickup-points/managed');
  },
  
  getById: async (id: number): Promise<PickupPoint> => {
    return apiClient.get<PickupPoint>(`/pickup-points/${id}`);
  },

  create: async (data: CreatePickupPointDto): Promise<PickupPoint> => {
    return apiClient.post<PickupPoint>('/pickup-points', data);
  },

  update: async (id: number, data: UpdatePickupPointDto): Promise<PickupPoint> => {
    return apiClient.patch<PickupPoint>(`/pickup-points/${id}`, data);
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/pickup-points/${id}`);
  },

  addException: async (id: number, data: AddExceptionDto): Promise<PickupPoint> => {
    return apiClient.post<PickupPoint>(`/pickup-points/${id}/exceptions`, data);
  },

  updateException: async (id: number, exceptionIndex: number, data: UpdateExceptionDto): Promise<PickupPoint> => {
    return apiClient.put<PickupPoint>(`/pickup-points/${id}/exceptions/${exceptionIndex}`, data);
  },

  deleteException: async (id: number, exceptionIndex: number): Promise<PickupPoint> => {
    return apiClient.delete<PickupPoint>(`/pickup-points/${id}/exceptions/${exceptionIndex}`);
  },
};
